const CLOUD_NAME = "penta1hz";

const UPLOAD_PRESET = "qss_projects";

export const uploadToCloudinary = async (file, resourceType = "image") => {
  if (!file) {
    throw new Error("No file selected.");
  }

  // =========================
  // FILE SIZE CHECK
  // =========================

  const MAX_IMAGE_SIZE = 10 * 1024 * 1024; // 10 MB

  const MAX_VIDEO_SIZE = 100 * 1024 * 1024; // 100 MB

  if (resourceType === "image" && file.size > MAX_IMAGE_SIZE) {
    throw new Error(
      `Image "${file.name}" is too large. Maximum allowed size is 10 MB.`,
    );
  }

  if (resourceType === "video" && file.size > MAX_VIDEO_SIZE) {
    throw new Error(
      `Video "${file.name}" is too large. Maximum allowed size is 100 MB.`,
    );
  }

  const formData = new FormData();

  formData.append("file", file);

  formData.append("upload_preset", UPLOAD_PRESET);

  const uploadUrl = `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/${resourceType}/upload`;

  const response = await fetch(uploadUrl, {
    method: "POST",
    body: formData,
  });

  const data = await response.json();

  if (!response.ok) {
    console.error("Cloudinary upload failed:", data);

    throw new Error(data.error?.message || "Cloudinary upload failed.");
  }

  return data.secure_url;
};
